@if (!hidden) {
  <nav>
    <!-- eslint-disable-next-line  @angular-eslint/template/interactive-supports-focus-->
    <div class="td-wb-fab-menu__backdrop"
         [ngClass]="{ 'td-wb-fab-menu__backdrop--visible': mobileToolbarExpanded }"
         (click)="onBackdropClicked()"></div>
    <ul #fabMenu
        class="td-wb-fab-menu__container"
        role="toolbar"
        [ngClass]="{ 'td-wb-fab-menu__container--collapsed': !mobileToolbarExpanded,
                   'td-wb-fab-menu__container--with-our-chat': isChatButtonOnPage === 'OUR_BUTTON',
                   'td-wb-fab-menu__container--with-chat': isChatButtonOnPage === 'CHAT_SERVICES_BUTTON',
                   'td-wb-fab-menu__container--with-chat--french': isChatButtonOnPage === 'CHAT_SERVICES_BUTTON' && currentLanguage === 'fr'}">
      @if (!fabOverlapsFocusable) {
        <li class="td-wb-fab-menu__button-container td-wb-fab-menu__button-container--fab"
            role="none">
          <a role="button"
             tabindex="0"
             href=""
             id="td-wb-fab-toggle"
             [attr.aria-label]="'tdWb.menu.TOOLBAR_HEADER' | tdWbTranslate"
             [attr.aria-expanded]="mobileToolbarExpanded"
             (keydown.enter)="onToolbarExpandCollapse('quick-links')"
             (click)="onToolbarExpandCollapse('quick-links')">
            <span class="td-wb-fab-menu__icon-container">
              <td-wb-icon iconId="quick-links"
                          size="44" />
            </span>
          </a>
        </li>
      }
      @for (utility of utilityToolbar; track utility) {
        @if (mobileToolbarExpanded) {
          <li
            class="td-wb-fab-menu__button-container td-wb-fab-menu__button-container--item"
            role="none">
            <a role="button"
               tabindex="0"
               [href]="utility.href"
               [attr.id]="'td-wb-fab-menu-' + utility.id"
               [attr.target]="utility.target"
               (click)="onToolbarExpandCollapse()">
              <span class="td-wb-fab-menu__icon-container">
                <td-wb-icon [iconId]="removeIconPrefix(utility.icon.cssClass)"
                            size="35" />
              </span>
              <div class="td-wb-fab-menu__button-label"
                   [innerHtml]="utility.text"></div>
            </a>
          </li>
        }
      }
    </ul>
  </nav>
}
